// True when the app is being served from the MapleCoin custom domain
// (app.maplecoin.ca in prod, staging.maplecoin.ca in staging). Same Static Web App bundle as the other brands; this
// lets the shared root route pick the MapleCoin login/auth experience by hostname.
// Anchored on the dot so a lookalike ("notmaplecoin.ca") never matches.
export function isMapleCoinHost(hostname?: string): boolean {
  const raw = hostname ?? (typeof window === "undefined" ? "" : window.location.hostname);
  const host = raw.toLowerCase();
  return host === "maplecoin.ca" || host.endsWith(".maplecoin.ca");
}
